import { FixedAsset } from "./FixedAsset";
import { Inventory } from "./Inventory";

export interface CommercialDocument {
  id: number;
  contact_id: number;
  reference: string;
  status: string;
  total_amount: string;
  issue_date: string;
  due_date: string;
  supply_date: string;
  doc_kind?: string;
  inventory_id?: number;
  description?: string;
  untracked_products_count?: number;
  addition_transactions_count?: number;
  type?: string;
}

export interface AllCommercialDocuments {
  documents: CommercialDocument[];
}

export interface LineItem {
  id: number;
  quantity: number;
  unit_price: number;
  product_id?: number;
  product_description?: string;
  is_inclusive: boolean;
  discount_percentage: number;
  discount_type: string;
  total_before_vat?: number;
  tax_id: number;
  unit_type: number;
  vat_value?: number;
  amount?: number;
  product?: FixedAsset;
}

export interface Bill extends CommercialDocument {
  line_items?: LineItem[];
  bill_items?: LineItem[];
  bill_items_attributes?: LineItem[];
  inventory?: Inventory;
}

export enum CommercialDocumentName {
  INVOICE = "invoice",
  CREDIT_NOTE = "credit_note",
  DEBIT_NOTE = "debit_note",
}
